/**
 * A copy of a shared-lib `getCalendlyInterviewsInfoStatus` function to calculate the interview info status for an offer.
 * Calendly Interviews are requested and updates separately from offer, but offer keeps the calculated field - calendlyInterviewsInfoStatus
 * that needs in the side panel of a student details view.
 *
 * To keep UI fluid and not rely upon backend to quickly update the offer,
 * this function is used in a saga that listens StudentActionTypes.TOGGLE_SCHEDULED_INTERVIEW_SUCCESS action,
 * and updates the `calendlyInterviewsInfoStatus` in the offer.
 * */

import { EventInfoStatus, ICalendlyEvent } from 'api-paths-cas';

export function getCalendlyInterviewsInfoStatus(calendlyInterviews: Array<ICalendlyEvent>): EventInfoStatus {
  const statusesByPriority = [
    EventInfoStatus.INVITED,
    EventInfoStatus.BOOKED,
    EventInfoStatus.FAILED,
    EventInfoStatus.PASSED,
    EventInfoStatus.RESIT,
    EventInfoStatus.NONE,
  ];

  const status = statusesByPriority.find(sts => {
    return calendlyInterviews.some(interview => {
      return Object.values(interview.scheduledEvents ?? {}).some(event => {
        return sts === event.infoStatus;
      });
    });
  });

  return status ?? EventInfoStatus.NONE;
}
